export default "__VITE_ASSET__DPqI$mef__"